import React from "react";

const DropOffProcedure=()=>{
    
   return(
    <div className="container p-3">
    <div className="container-3 p-4 vh-70">
        <span style={{fontSize:20, fontFamily:700}}>Drop off procedure:</span><br></br><br></br>
        <span style={{fontSize:15, fontFamily:300}}>1) Locate the QR code in your email inbox provided to on our website. Once you have located it, put your device(s) in sturdy box, which could fit your device(s), pack your device(s)  with appropriate packing cushionig materiales  inside the sturdy box and bring it to your local Canada Post drop-off location  for shipping.</span>
        <br></br><br></br>
        <span style={{fontSize:15, fontFamily:300}}>2) Bring the QR code to your local Canada Post drop-off location and get a mail box that will fit your items, if you  not already have packed your device(s), show your QR code to agent at the drop off location and handover your package to them.</span>
        <br></br><br></br>
        <span style={{fontSize:15, fontFamily:300}}>3)Be sure to pack it carefully and securely before handing it over ot agent to avoid damage during the transit.</span>

            </div>                    
                               
</div>
   )
}
export default DropOffProcedure;